<template>
  <a-drawer
    :maskClosable="false"
    width="75%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <Flowing :userId="userId" v-if="open && userId"></Flowing>
  </a-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import Flowing from '../flowing .vue'
import { getObj, addObj, putObj } from '@/api/pressure/device'
export default {
  name: 'Folowing',
  components: {
    Flowing,
  },
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      open: false,
      userId: '',
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      this.userId = ''
      const that = this
      that.open = false
      // this.$confirm({
      //   title: '是否确认关闭清空数据',
      //   onOk() {
      //     console.log(that.open, 'openopen')
      //     that.open = false
      //   },
      //   onCancel() {},
      // })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
       this.onClose()
      this.reset()
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加设备'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      console.log(row, 'rowrow')
      this.userId = row.userId
      this.open = true
      this.formTitle = '账户流水'
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
